import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

// modals
import NewTogglerModal from "./NewTogglerModal";

// constants
import constants from "../../constants";

// utils
import { saveUTM } from "../../utils";

// mixpanel
import {
  trackNavLinkClick,
  trackCTAClick,
  trackLogoClick,
  trackMobileMenuToggle,
} from "./headerMixpanel";

// styles
import * as styles from "./NewHeader.module.css";

const NewHeader = props => {
  const [showTogglerModal, setShowTogglerModal] = useState(false);

  // Get current pathname
  const currentPath = props.location?.pathname || "";

  // Get constants
  const { HEADER_NAV_ITEMS, HEADER_CTA_BUTTONS, MIXPANEL_HEADER_CONFIG } =
    constants;

  // Save UTM parameters on mount
  useEffect(() => {
    if (props.location?.search) {
      saveUTM(props.location.search);
    }
  }, [props.location?.search]);

  // Handle mobile menu toggle with tracking
  const handleMobileMenuToggle = isOpen => {
    setShowTogglerModal(isOpen);
    trackMobileMenuToggle(isOpen, currentPath);
  };

  return (
    <>
      <div className={styles.headerWrapper}>
        <nav className={`navbar navbar-expand-xl fixed-top ${styles.navBar}`}>
          <div className={`container ${styles.navbarContainer}`}>
            {/* Logo */}
            <div className="navbar-brand">
              <Link
                to="/"
                onClick={() =>
                  trackLogoClick(
                    MIXPANEL_HEADER_CONFIG.locations.header,
                    currentPath
                  )
                }
              >
                <StaticImage
                  src="../../images/twin-logo/twin_new_logo.png"
                  alt="Twin Health India Logo"
                  placeholder="blurred"
                  quality={90}
                  className={styles.logoImage}
                />
              </Link>
            </div>

            {/* Desktop Navigation */}
            <div className="collapse navbar-collapse justify-content-end">
              <ul className={`navbar-nav ${styles.navBarList}`}>
                {HEADER_NAV_ITEMS.map((item, index) => {
                  const isActive = currentPath === item.link;
                  return (
                    <li key={index} className="nav-item">
                      <Link
                        to={item.link}
                        className={`nav-link ${
                          isActive ? styles.activeLink : ""
                        }`}
                        onClick={() =>
                          trackNavLinkClick(
                            item.label,
                            MIXPANEL_HEADER_CONFIG.locations.header,
                            currentPath
                          )
                        }
                      >
                        {item.label}
                      </Link>
                    </li>
                  );
                })}
              </ul>

              {/* Desktop CTAs */}
              <div className={styles.ctaButtons}>
                <Link
                  to={HEADER_CTA_BUTTONS.contact.link}
                  className={styles.contactBtn}
                  onClick={() =>
                    trackCTAClick(
                      HEADER_CTA_BUTTONS.contact.label,
                      MIXPANEL_HEADER_CONFIG.locations.header,
                      currentPath
                    )
                  }
                >
                  {HEADER_CTA_BUTTONS.contact.label}
                </Link>
                <Link
                  to={HEADER_CTA_BUTTONS.enroll.link}
                  className={styles.enrollBtn}
                  onClick={() =>
                    trackCTAClick(
                      HEADER_CTA_BUTTONS.enroll.label,
                      MIXPANEL_HEADER_CONFIG.locations.header,
                      currentPath
                    )
                  }
                >
                  <span>{HEADER_CTA_BUTTONS.enroll.label}</span>
                  <StaticImage
                    src="../../images/icons/header_cta_icn.png"
                    alt="Enroll Icon Icon"
                    placeholder="none"
                    quality={100}
                    formats={["auto", "webp", "avif"]}
                    className={styles.enrollIcon}
                  />
                </Link>
              </div>
            </div>

            {/* Mobile Menu Button */}
            <div className={styles.mobileMenuWrapper}>
              <button
                className={styles.menuButton}
                onClick={() => handleMobileMenuToggle(true)}
                aria-label="Open menu"
              >
                <span>Menu</span>
              </button>
            </div>
          </div>
        </nav>
      </div>

      {/* Mobile Menu Modal */}
      <NewTogglerModal
        show={showTogglerModal}
        onHide={() => handleMobileMenuToggle(false)}
        navItems={HEADER_NAV_ITEMS}
        currentPath={currentPath}
        ctaButtons={HEADER_CTA_BUTTONS}
        mixpanelConfig={MIXPANEL_HEADER_CONFIG}
      />
    </>
  );
};

export default NewHeader;
